import { type AttributeFilters, attributeFiltersSchema } from '@ipfabric/utils';

const GLOBAL_ATTRIBUTE_FILTERS_KEY = 'globalAttributeFilters';

export const globalAttributeFiltersLocalStorage = {
  set: (value: AttributeFilters): void => {
    localStorage.setItem(GLOBAL_ATTRIBUTE_FILTERS_KEY, JSON.stringify(value));
  },
  get: (): AttributeFilters => {
    const attributeFilters = localStorage.getItem(GLOBAL_ATTRIBUTE_FILTERS_KEY);

    if (!attributeFilters) {
      return {};
    }

    const parsedAttributeFilters = JSON.parse(attributeFilters);
    const valid = !attributeFiltersSchema.validate(parsedAttributeFilters)
      .error;

    return valid ? parsedAttributeFilters : {};
  },
};
